export const nativePlatformFiltersInitialState = {
  contentTagFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'contentTagFilter',
    translateKey: 'filter:contentsTag',
  },
  wordCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'wordCloudFilter',
    translateKey: 'filter:wordCloud',
  },
  seenStatusFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both',
    componentName: 'seenStatusFilter',
    translateKey: 'filter:seenStatus',
  },
  hashtagCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'hashtagCloudFilter',
    translateKey: 'filter:hashtagCloud',
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'nativePlatforms',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:contentBasedOn',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  contentTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both',
    platform: 'nativePlatforms',
    componentName: 'contentTypeFilter',
    translateKey: 'filter:contentType',
  },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'nativePlatforms',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    platform: 'nativePlatforms',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    selectedValue: '',
    filterType: 'include',
    hasIncludeExclude: true,
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'nativePlatforms',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
};
